module.exports = __webpack_public_path__ + "img/restaurant_operations.d2f8c638.jpg";